import { EnglishArabicDTO } from "bbsf-controls"
export class LookupGroupModel
{
      Id:number
      Name :EnglishArabicDTO=new EnglishArabicDTO();
      IDEncrypted :string
}
     